import { call, takeLatest } from 'redux-saga/effects';
import * as constants from './user-settings.constants';
import * as types from './user-settings.types';
import * as services from './user-settings.saga-services';

function* invokeUpdateUserSettings(action: types.IUpdateUserSettings) {
  yield call(services.updateUserSettings, action.payload);
}

function* invokeUpdateUserWidgetVisibility(action: types.IStoreUserWidgetVisibility) {
  yield call(services.updateUserWidgetVisibility, action.payload);
}

function* invokeGetUserSettings() {
  yield call(services.getUserSettings);
}

function* invokeReorderUserWidgets(action: types.IReorderUserWidgets) {
  yield call(services.reorderUserWidgets, action.payload);
}

function* invokeUpdateUserWidgetSize(action: types.IUpdateUserWidgetSize) {
  yield call(services.updateUserWidgetSize, action.payload);
}

export function* watchUserSettingsPageSaga() {
  yield takeLatest(constants.UPDATE_USER_SETTINGS, invokeUpdateUserSettings);
  yield takeLatest(constants.STORE_USER_WIDGET_VISIBILITY, invokeUpdateUserWidgetVisibility);
  yield takeLatest(constants.REORDER_USER_WIDGETS, invokeReorderUserWidgets);
  yield takeLatest(constants.GET_USER_SETTINGS, invokeGetUserSettings);
  yield takeLatest(constants.UPDATE_USER_WIDGET_SIZE, invokeUpdateUserWidgetSize);
}
